import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';

import { IWizardOptions } from '../../../models';

declare var $: any;
import * as _ from 'lodash';
@Component({
    selector: 'wizard-room',
    templateUrl: './room.component.html',
    styleUrls: ['./room.component.scss', '../../form-styles.scss']
})
export class RoomComponent extends BaseComponent implements OnInit {
    public hasRoomProviders = false;
    public selectedRoom = { capacity: 0 };
    private defaultsSubscription: Subscription;

    constructor(private wizardService: WizardService) {
        super();
    }

    ngOnInit() {
        this.hasRoomProviders = this.checkHasRoomProviders();
        this.subscribeToMeetingDefaultsUpdates();
        this.restoreRoomIfExists();
        this.initRoom();
    }

    ngOnDestroy() {
        this.defaultsSubscription.unsubscribe();
    }

    private subscribeToMeetingDefaultsUpdates() {
        this.defaultsSubscription = this.wizardService.onNewDefaultOptions$.subscribe((defaults: IWizardOptions) => {
            if (defaults?.room?.capacity) {
                this.updateRoom(defaults.room.capacity, true);
            } else {
                this.updateRoom('not required', true);
            }
        });
    }

    private initRoom() {
        $('#room').dropdown({
            placeholder: 'No room',
            values: [
                {
                    name: 'No room',
                    value: 'not required'
                },
                ...this.generateRoomValues()
            ],
            onChange: (value) => {
                if (value) {
                    this.updateRoom(value);
                }
            }
        });
    }

    private restoreRoomIfExists() {
        if (this.wizardService.options.room) {
            this.selectedRoom = this.wizardService.options.room;
        }
    }

    private checkHasRoomProviders() {
        return this.wizardService.taskMetaData && this.wizardService.taskMetaData.calendar.hasRoomProviders;
    }

    private generateRoomValues(): { name: string; value: number; selected: boolean }[] {
        const minRoomCapacity = 1;
        const maxRoomCapacity = 24;

        return Array.from(Array(maxRoomCapacity).keys()).map((capacity) => {
            capacity += minRoomCapacity;
            const templateString = `Room for ${capacity}`;

            return {
                name: templateString,
                value: capacity,
                selected: this.selectedRoom.capacity === capacity
            };
        });
    }

    private updateRoom(value: string | number, shouldSetDropdownValue = false) {
        const capacity = value === 'not required' ? null : { capacity: _.toNumber(value) };
        this.wizardService.updateOptions({
            room: capacity
        });

        if (shouldSetDropdownValue) $('#room').dropdown('set selected', value);
    }
}
